import React from 'react';
import {useTranslation} from "react-i18next";

import APIModel from "../../Components/APIModel";
import {store} from "../../configureStore";


const Categories = (
    {
        match,
    }
) => {
    const {t, i18n} = useTranslation();

    const CATEGORIES_COLUMNS = [
        {
            name: t('catalog.categories.columns.name', 'Name'),
            cell: row => {
                if (!row.name) {
                    return '';
                }

                // let langByDefault = store.getState().Shops.activeShop.lang_by_default;
                // return String(row.name[langByDefault])
                return String(row.name)
            }
        },
        {
            name: t('catalog.categories.columns.is_active', "Is active"),
            cell: row => <div>
                {row.is_active ? '✅' : '⏹'}
            </div>
        },
        {
            name: t('catalog.categories.columns.parent_category', 'Parent category'),
            cell: row => {
                if (!row.parent_category) {
                    return '';
                }

                const fieldName = 'name';
                let langByDefault = store.getState().Shops.activeShop.lang_by_default;
                const res = row.parent_category[`${fieldName}_${langByDefault}`] ? row.parent_category[`${fieldName}_${langByDefault}`] : row.parent_category[`${fieldName}`];
                return String(res)
            }
        },
        {
            name: t('catalog.categories.columns.sort_order', 'Sort order'),
            selector: "sort_order",
        },
    ];

    return <APIModel
        heading={t('catalog.categories.api_model.heading', 'Product categories')}
        subheading=''
        icon="pe-7s-folder icon-gradient bg-sunny-morning"
        apiPath='shop/categories'
        tableColumns={CATEGORIES_COLUMNS}
        tableEmptyMessage={t('catalog.categories.api_model.message_empty', 'No categories')}
        match={match}
        hasFilters={true}
    />;
};

export default Categories;
